import { Navigate, useParams } from 'react-router'

import { PathNotFound } from 'tools/Uniform'

import { TYPES } from '../defs'

function nameAsId(n) {
  return n.toLowerCase().replace(' ', '')
}

////////////////////////////////////////////////////////////////////////////////
export function genNavPoint(title, lazy, opts = {}) {
  let out = []
  const {
    idPath: _, // to cut out idPath
    index = false,
    id = nameAsId(opts.idPath || opts.id || title),
    path = nameAsId(opts.idPath || title),
    icon,
    nav = {},
    route = {},
    children,
    ...rest
  } = opts

  if (icon && !nav.icon) {
    nav.icon = icon
  }

  // always add a not found... if needed add a 'noDefaultRoute: true' option
  if (children?.length > 0) {
    children.push(genNotFound()) // eslint-disable-line no-restricted-syntax
  }

  return out.concat({
    id,
    title,
    nav,
    type: TYPES.ROUTE,
    route: genLazyTo(lazy, { ...route, index, path }),
    children,
    ...rest
  })
}

////////////////////////////////////////////////////////////////////////////////
export function genNotFound() {
  return {
    id: 'notfound',
    type: TYPES.ROUTE,
    route: { path: '*', element: <PathNotFound /> }
  }
}

////////////////////////////////////////////////////////////////////////////////
export function genNavPointPath(title, path, lazy, opts = {}) {
  return genNavPoint(title, lazy, { ...opts, path })
}

////////////////////////////////////////////////////////////////////////////////
export const genLazyTo = (lazy, rest = {}) => ({ lazy, ...rest })

export function genIndex(opts) {
  let {
    id = 'index',
    path = null,
    index = true,
    lazy,
    component,
    element,
    nav = {},
    route: routeData = {},
    ...rest
  } = opts

  nav = { ...nav, visible: false }
  let route
  if (lazy) route = genLazyTo(lazy, { ...routeData, index, path })
  else if (component) route = { ...routeData, index, path, component }
  else if (element) route = { ...routeData, index, path, element }
  else throw new Error('Invalid genIndex: no lazy/component/redirect')

  return { id, title: 'Home', nav, route, type: TYPES.ROUTE, ...rest }
}

export function genRedirect(func, { external, ...opts } = {}) {
  if (external) {
    let { path, idPath, id, ...rest } = opts
    id = nameAsId(idPath || id)
    return {
      ...rest,
      id,
      route: {
        path,
        loader: ({ params }) => window.location.replace(func(params))
      }
    }
  }
  return genIndex({ element: <RedirectTo to={func} replace />, ...opts })
}

// this is a few hoops all so we can use pathTo() which isn't available to us
// in generate; so now we can pass it in as a function then put that result
// into <Navigate />
export function RedirectTo({ to, replace = true }) {
  const params = useParams()

  return <Navigate to={to(params)} replace={replace} />
}

// ////////////////////////////////////////////////////////////////////////////////
// export function genMenuDivider({ name, menuAdd }) {
//   return console.inspect({
//     id: 'div_' + nameAsId(name),
//     nav: { name, menuAdd: getListValue(menuAdd) }
//   })
// }

////////////////////////////////////////////////////////////////////////////////
// export function genTab(name, opts = {}) {
//   const { id = nameAsId(name), ...rest } = opts
//   return {
//     ...rest,
//     id,
//     nav: { name },
//     type: TYPES.TAB
//   }
// }

////////////////////////////////////////////////////////////////////////////////
// export const MENU_PUSH = Symbol('MENU_PUSH')

function getListValue(value) {
  switch (typeof value) {
    case 'string':
      return { order: null, value: [value] }
    case 'object':
      if (Array.isArray(value)) return { order: null, value: value }
      else return value
    default:
      return undefined
  }
}

function tabMenu(key, opts) {
  const value = getListValue(opts[key])
  if (value) {
    return { [key]: value }
  }
  return {}
}

export function tabMenus(opts) {
  return {
    ...opts,
    ...tabMenu('tabHead', opts),
    ...tabMenu('tabAdd', opts),
    ...tabMenu('menuHead', opts),
    ...tabMenu('menuAdd', opts)
  }
}
